module.exports = __webpack_public_path__ + "static/img/arthroscopy-04.5fbfd8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/arthroscopypic/arthroscopy-04.jpg
// module id = nfD9
// module chunks = 52